import { useState } from "react";
import { customEvent } from "goi_common";

import { ArrowRightIcon, DocumentIcon } from "@/components/DirectionsIcons";
import { DirectionsChecklistModal } from "@/containers/DirectionsDetailContainer/components/DirectionsChecklistModal";
import type { MubinsoTemplate } from "@/utils/buildMubinsoPageProps";

interface MubinsoFixedBarProps {
  parlorId: number;
  /** 비용 섹션 CTA 와 같은 목적지(무빈소 퍼널). utm_content 만 fixed 로 다르다 */
  ctaHref: string;
  /** B 는 버튼 문구를 "무빈소 장례 절차 및 비용 자세히 알아보기" 로 쓴다 */
  variant?: MubinsoTemplate;
}

/**
 * 하단 고정 CTA.
 *
 * 왼쪽은 체크리스트로 지금 통화할 상황이 아닌 사람의 연락처를 남기고,
 * 오른쪽은 비용 섹션 CTA 와 같은 무빈소 퍼널로 보낸다.
 * 체크리스트 모달은 directions 에서 쓰던 것을 그대로 재사용한다.
 */
export const MubinsoFixedBar = ({
  parlorId,
  ctaHref,
  variant = "A",
}: MubinsoFixedBarProps) => {
  const [isChecklistOpen, setIsChecklistOpen] = useState(false);

  return (
    <>
      <div className="mb-fixedbar" role="region" aria-label="장례 상담">
        <div className="mb-fixedbar__inner">
          <button
            type="button"
            className="mb-fixedbar__cta mb-fixedbar__cta--ghost"
            onClick={() => {
              customEvent({
                newGtm: {
                  path: "prlr_mubinso",
                  trigger_and_target: "i_fixed_checklist",
                  properties: { parlor_id: parlorId, cta_position: "fixed" },
                },
              });
              setIsChecklistOpen(true);
            }}
          >
            <DocumentIcon size={20} style={{ flexShrink: 0 }} />
            <span className="mb-fixedbar__stack">
              <span className="mb-fixedbar__eyebrow">임종 준비</span>
              <span className="mb-fixedbar__main">체크리스트 받기</span>
            </span>
          </button>

          <a
            className="mb-fixedbar__cta mb-fixedbar__cta--primary"
            href={ctaHref}
            onClick={() =>
              customEvent({
                newGtm: {
                  path: "prlr_mubinso",
                  trigger_and_target: "i_fixed_cost",
                  properties: { parlor_id: parlorId, cta_position: "fixed" },
                },
              })
            }
          >
            <span className="mb-fixedbar__stack">
              <span className="mb-fixedbar__eyebrow">
                {variant === "B" ? "무빈소 장례 절차 및 비용" : "무빈소 장례"}
              </span>
              <span className="mb-fixedbar__main">
                자세히 알아보기
                <ArrowRightIcon size={14} style={{ marginLeft: 4 }} />
              </span>
            </span>
          </a>
        </div>
      </div>

      <DirectionsChecklistModal
        isOpen={isChecklistOpen}
        onClose={() => setIsChecklistOpen(false)}
        parlorId={parlorId}
        eventPath="prlr_mubinso"
      />
    </>
  );
};
